import React, {Component} from 'react'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

import {
    PAYMENT_REQUIRED,
    INSUFFICIENT_FUNDS
} from "../../../constants/chatInterface";

class PpvInfoPopup extends Popup {
    constructor(props) {
        super(props);
        this.setState(props);
        this.onJoinClick = this.onJoinClick.bind(this);
        this.onReplenishClick = this.onReplenishClick.bind(this);

        this.userClosable = false;
        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    open(newProps) {
        this.setState({errorData: null, ...newProps});
        super.open();
    }

    onJoinClick() {
        let chatInterface = Registry.get('chatInterface');
        chatInterface.setAuthParams({payment_allowed : true});

        chatInterface.login();
        PpvInfoPopup.close();
    }

    onReplenishClick(e) {
        e.preventDefault();
        window.open('/membre/wallet/replenish');
    }

    render() {
        let lang = Registry.get('locale');

        let store = Registry.get('store');
        let {currentUser, currentRoom} = store.getState();

        let price = this.props.price;
        if (this.state.price) price = this.state.price;

        let walletAmount = 0;
        let nick = "";

        if (currentUser && currentUser.wallet_amount) {
            walletAmount = currentUser.wallet_amount;
        } else {
            walletAmount = __currentUser.counters.amount_wallet;
        }

        if (currentRoom && currentRoom.creator && currentRoom.creator.nick) {
            nick = currentRoom.creator.nick;
        }

        if (this.props.creator_nick) { nick = this.props.creator_nick; }
        if (this.state.creator_nick) { nick = this.state.creator_nick; }

        // TODO: Move error_data from state
        if (this.state.error_data) {
            if (this.state.error_data.amount_available) {
                walletAmount = this.state.error_data.amount_available;
            }
        }


        let {chatUrlSecondary, chatroomNameSecondary, chatroomName, message, closeButton, mainRoomButton} = this.props;

        let mainRoomUrl = Registry.get('chatInterface').getPrimaryRoomURL();

        let className = 'popup popup-ppv-info ' + this.state.visibility;


        return (
            <div className={className} ref={(ref) => this._ref = ref}>

            {this.state.reason == INSUFFICIENT_FUNDS ? <p>ERROR: Insufficient funds</p> : null}

            <p>{lang.showroom_welcome(nick)}</p>
            <p>{lang.showroom_price(price)}</p>

            <p>{lang.your_tokens_amount(walletAmount)} <a href="#" className="credit-your-wallet" onClick={this.onReplenishClick}>{lang.replenish_your_wallet}</a></p>

            <p>
                <a className="popup-button enter" href="#" onClick={this.onJoinClick}>{lang.join_show}</a>
                <a className="popup-button" href={mainRoomUrl}>{lang.enter_main_room}</a>
            </p>
            </div>);
    }
}

PpvInfoPopup.generateKey = function() { return 'ppv-info-popup' };
PpvInfoPopup.mount = function(props, onMount) { return Popup.mount(PpvInfoPopup, props, onMount) };
PpvInfoPopup.open = function(props) {
    let id = PpvInfoPopup.generateKey(props);

    if (!Popup.popups[id]) {
        PpvInfoPopup.mount(props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open(props)
    }
};
PpvInfoPopup.close = function(props) {
    let id = PpvInfoPopup.generateKey(props);

    if (Popup.popups[id]) {
        Popup.popups[id].close();
    }
};

export default PpvInfoPopup;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PpvInfoPopup/index.js